export default __webpack_public_path__ + "static/media/partners-logo-zer-01-ne-w@3x.a38d8131.webp";